import { v4 as uuidv4 } from "uuid";

export const menuData = [
  {
    id: uuidv4(),
    title: "Home",
    subItems: [
      {
        id: uuidv4(),
        title: "Home",
        path: "/",
        relatedWords: [
          "home",
          "inicio",
          "ir a inicio",
          "principal",
          "dashboard",
          "panel",
          "menú principal",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Usuarios",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar Usuarios",
        path: "/usuarios",
        relatedWords: [
          "usuarios",
          "administrar usuarios",
          "ver usuarios",
          "gestión de usuarios",
          "empleados",
          "personal",
          "permisos",
          "accesos",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Clientes",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar Clientes",
        path: "/clientes",
        relatedWords: [
          "administrar clientes",
          "ver clientes",
          "gestión de clientes",
          "listado de clientes",
          "buscar cliente",
          "cartera de clientes",
          "clientes activos",
          "datos de clientes",
        ],
      },
      {
        id: uuidv4(),
        title: "Deuda inicial",
        path: "/clientes/deuda-inicial",
        relatedWords: [
          "deuda",
          "deuda inicial",
          "ver deuda",
          "ver deuda inicial",
          "saldo inicial",
          "balance inicial",
          "deuda histórica",
          "cargar deuda",
        ],
      },
      {
        id: uuidv4(),
        title: "Deudores",
        path: "/clientes/deudores",
        relatedWords: [
          "deudores",
          "ver deudores",
          "clientes deudores",
          "morosos",
          "deudas pendientes",
          "cuentas por cobrar",
          "clientes con deuda",
          "gestión de deudores",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Proveedores",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar Proveedores",
        path: "/proveedores",
        relatedWords: ["administrar proveedores", "ver proveedores"],
      },
      {
        id: uuidv4(),
        title: "Marcas",
        path: "/proveedores/marcas",
        relatedWords: ["marcas", "ver marcas", "administrar marcas"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Inventario",
    subItems: [
      {
        id: uuidv4(),
        title: "Inventario",
        path: "/inventario",
        relatedWords: [
          "inventario",
          "ver inventario",
          "stock",
          "existencias",
          "mercadería",
          "productos en stock",
          "gestión de inventario",
          "control de stock",
          "almacén",
        ],
      },
      {
        id: uuidv4(),
        title: "Categorías",
        path: "/inventario/categorias",
        relatedWords: [
          "categorías",
          "ver categorías",
          "rubros",
          "clasificación",
          "tipos de productos",
          "grupos",
          "familias de productos",
        ],
      },
      {
        id: uuidv4(),
        title: "Locales",
        path: "/inventario/locales",
        relatedWords: ["locales", "sucursales", "ver locales"],
      },
      {
        id: uuidv4(),
        title: "Productos",
        path: "/inventario/productos",
        relatedWords: ["productos", "ver productos", "administrar productos"],
      },
      {
        id: uuidv4(),
        title: "Sueltos",
        path: "/inventario/sueltos",
        relatedWords: ["productos sueltos", "ver sueltos"],
      },
      {
        id: uuidv4(),
        title: "Grupos de productos",
        path: "/inventario/grupos",
        relatedWords: [
          "grupos",
          "grupo de productos",
          "agrupar productos",
          "conjunto de productos",
        ],
      },
      {
        id: uuidv4(),
        title: "Recordatorios de reposición",
        path: "/ventas/recordatorios",
        relatedWords: [
          "recordatorios",
          "reposicion",
          "avisar al cliente",
          "se le acaba",
          "recompra",
        ],
      },
      {
        id: uuidv4(),
        title: "Grupos de consumo",
        path: "/inventario/grupos-de-consumo",
        relatedWords: [
          "consumo",
          "duracion",
          "cuanto dura",
          "reposicion",
          "recordatorios",
          "dias",
        ],
      },
      {
        id: uuidv4(),
        title: "Transferencia de mercaderías",
        path: "/inventario/transferencia-de-mercaderia",
        relatedWords: ["transferencias", "movimientos", "traspasos"],
      },
      {
        id: uuidv4(),
        title: "Stocks mínimos",
        path: "/inventario/stocks-minimos",
        relatedWords: [
          "stocks mínimos",
          "alertas de stock",
          "punto de reorden",
          "stock crítico",
          "faltantes",
          "control de mínimos",
          "niveles de stock",
          "productos por comprar",
        ],
      },
      {
        id: uuidv4(),
        title: "Valuación de inventario",
        path: "/inventario/valuacion",
        relatedWords: [
          "valuación",
          "valor del inventario",
          "costo de inventario",
          "valorización",
          "valor de stock",
          "inventario valorizado",
          "costo de mercadería",
          "valor de existencias",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Precios y costos",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar Precios",
        path: "/precios",
        relatedWords: [
          "precios",
          "administrar precios",
          "gestión de precios",
          "modificar precios",
          "actualizar precios",
          "precios de venta",
          "lista de precios",
          "cambio de precios",
        ],
      },
      {
        id: uuidv4(),
        title: "Plantillas",
        path: "/precios/plantillas",
        relatedWords: ["plantillas", "templates"],
      },
      {
        id: uuidv4(),
        title: "Aumento masivo",
        path: "/precios/aumento-masivo",
        relatedWords: [
          "aumento masivo",
          "actualización masiva",
          "incremento de precios",
          "ajuste de precios",
          "aumentar precios",
          "modificación masiva",
          "actualizar todos los precios",
        ],
      },
      {
        id: uuidv4(),
        title: "Listas minoristas",
        path: "/precios/listas-minoristas",
        relatedWords: ["listas minoristas", "precios minoristas"],
      },
      {
        id: uuidv4(),
        title: "Planes minoristas",
        path: "/precios/planes-minoristas",
        relatedWords: ["planes minoristas"],
      },
      {
        id: uuidv4(),
        title: "Planes mayoristas",
        path: "/precios/planes-mayoristas",
        relatedWords: ["planes mayoristas"],
      },
      {
        id: uuidv4(),
        title: "Medios de pago y recargos",
        path: "/precios/recargos",
        relatedWords: ["medios de pago", "recargos"],
      },
      {
        id: uuidv4(),
        title: "Listas de precios",
        path: "/precios/listas-de-precios",
        relatedWords: ["listas de precios", "precios"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Compras",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar compras",
        path: "/compras",
        relatedWords: ["compras", "ver compras"],
      },
      {
        id: uuidv4(),
        title: "Vencimientos",
        path: "/compras/vencimientos",
        relatedWords: ["vencimientos", "productos vencidos"],
      },
      {
        id: uuidv4(),
        title: "Solicitud de compra",
        path: "/compras/solicitud-compra",
        relatedWords: ["solicitud", "pedido"],
      },
      {
        id: uuidv4(),
        title: "Pagos",
        path: "/compras/pagos",
        relatedWords: ["pagos", "pagos a proveedores"],
      },
      {
        id: uuidv4(),
        title: "Deuda inicial con proveedores",
        path: "/compras/deuda-inicial",
        relatedWords: ["deuda inicial", "deuda proveedores"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Ventas",
    subItems: [
      {
        id: uuidv4(),
        title: "Ordenes de venta",
        path: "/ventas",
        relatedWords: [
          "ventas",
          "órdenes",
          "pedidos",
          "vender",
          "facturar",
          "nueva venta",
          "punto de venta",
          "caja",
          "pos",
          "ordenes de venta",
          "tickets",
        ],
      },
      {
        id: uuidv4(),
        title: "Crear orden de venta",
        path: "/ventas/crear",
        relatedWords: ["nueva venta", "crear venta"],
      },
      {
        id: uuidv4(),
        title: "Facturación",
        path: "/ventas/facturacion",
        relatedWords: [
          "facturación",
          "facturas",
          "comprobantes",
          "recibos",
          "tickets",
          "emisión de facturas",
          "factura electrónica",
          "documentos de venta",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Reservas",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar reservas",
        path: "/reservas",
        relatedWords: ["reservas", "ver reservas"],
      },
      {
        id: uuidv4(),
        title: "Crear Reserva",
        path: "/reservas/crear",
        relatedWords: ["nueva reserva", "crear reserva"],
      },
      {
        id: uuidv4(),
        title: "Recursos",
        path: "/reservas/recursos",
        relatedWords: ["recursos", "unidades reservables"],
      },
      {
        id: uuidv4(),
        title: "Servicios",
        path: "/reservas/servicios",
        relatedWords: ["servicios"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Cobranzas",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar cobros",
        path: "/cobros",
        relatedWords: ["cobranzas", "cobros", "ver cobros"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Cupones y Ofertas",
    subItems: [
      {
        id: uuidv4(),
        title: "Cupones",
        path: "/cupones",
        relatedWords: ["cupones", "descuentos"],
      },
      {
        id: uuidv4(),
        title: "Ofertas",
        path: "/cupones/ofertas",
        relatedWords: ["ofertas", "promociones"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Tesorería",
    subItems: [
      {
        id: uuidv4(),
        title: "Caja",
        path: "/caja",
        relatedWords: [
          "caja",
          "tesorería",
          "efectivo",
          "dinero",
          "movimientos de caja",
          "flujo de caja",
          "ingresos",
          "egresos",
          "manejo de efectivo",
          "caja diaria",
        ],
      },
      {
        id: uuidv4(),
        title: "Cajas cerradas",
        path: "/caja/cajas-cerradas",
        relatedWords: ["cajas cerradas", "cierres de caja"],
      },
      {
        id: uuidv4(),
        title: "Gastos",
        path: "/caja/gastos",
        relatedWords: [
          "gastos",
          "egresos",
          "pagos",
          "salidas de dinero",
          "expensas",
          "costos",
          "gastos operativos",
          "registro de gastos",
          "cargar gasto",
        ],
      },
      {
        id: uuidv4(),
        title: "Adelanto de comisiones",
        path: "/caja/adelanto-de-comisiones",
        relatedWords: ["adelantos", "comisiones"],
      },
      {
        id: uuidv4(),
        title: "Cheques",
        path: "/caja/cheques",
        relatedWords: ["cheques", "valores"],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Tableros",
    subItems: [
      {
        id: uuidv4(),
        title: "Administrar Tableros",
        path: "/tableros",
        relatedWords: [
          "tableros",
          "administrar tableros",
          "ver tableros",
          "gestión de tableros",
          "kanban",
          "boards",
          "proyectos",
          "tareas",
          "organización",
          "flujo de trabajo",
          "workflow",
          "scrum",
          "agile",
          "columnas",
          "cards",
          "tarjetas",
          "seguimiento",
          "planificación",
          "gestión de proyectos",
          "asignaciones",
          "prioridades",
          "estado de tareas",
          "dashboard de proyectos",
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    title: "Configuración",
    subItems: [
      {
        id: uuidv4(),
        title: "Configuración",
        path: "/configuracion",
        relatedWords: ["configuración", "ajustes", "settings"],
      },
    ],
  },
];
